class DZModelDicLabel{
    id = "";
    name = "";
}
export default DZModelDicLabel;
